// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"97043868","50":"0c96f324","104":"33e30b72","208":"3949aeba","279":"503bab97","311":"a78974a4","372":"f4d928ba","453":"71f950f0","460":"594af999","618":"172d9535","664":"fcb39538","722":"1be36f3f","916":"9c0ba112"}[chunkId] + ".chunk.js";
};